import "./style.css";
import { Container, Navbar, /* NavDropdown */ Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import fullLogo from "../../assets/svg/logo3.svg"
import { useMediaQuery } from 'react-responsive';
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import MenuMobile from './menuMobile/index.jsx';
import { NavDropdown } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext.jsx";


const navLinkStyle1 = {
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 400,
  fontSize: 18,
  color: 'white',
};

const MotionNavLink = motion(NavLink);

export default function Header2() {

  const isMobile = useMediaQuery({ query: '(max-width: 1010px)' });

  // Dentro do componente Header2:
  const { user, logout } = useAuth();

  return (

    <header className="header fixed-top">
      <section className="breadcrumbs">
        <div className="container">
          {isMobile && (
            <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary w-100">
              <Container fluid className="d-flex justify-content-between">
                {/* Logo à esquerda */}
                <Navbar.Brand href="/home">
                  <img
                    src={fullLogo}
                    width="180"
                    height="55"
                    className="d-inline-block align-top"
                    alt="Logo República Sem Destino"
                  />
                </Navbar.Brand>
                <MenuMobile />
              </Container>
            </Navbar>
          )}


          {!isMobile && (
            <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary w-100 align-items-center">
              <Container fluid className="d-flex justify-content-between align-items-center">

                {/* Logo à esquerda */}
                <Navbar.Brand href="/welcome">
                  <img
                    src={fullLogo}
                    width="245"
                    height="55"
                    className="d-inline-block align-top"
                    alt="Logo República Sem Destino"
                  />
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                  <Nav className="ms-auto gap-1">

                    <MotionNavLink
                      to="/welcome"
                      end
                      className="nav-link custom-nav-link"
                      whileHover={{ scale: 1.05, color: "#1A9EE0" }}
                      transition={{ duration: 0.15 }}
                    >
                      INÍCIO
                    </MotionNavLink>


                    {/* 
                     <NavDropdown title="A SEM DESTINO" id="dropdown-sem-destino" className="custom-nav-link">
                     <NavDropdown.Item as={Link} to="/about">SOBRE</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/historia">HISTÓRIA</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/estrutura">ESTRUTURA</NavDropdown.Item>
                     </NavDropdown>
                     */}

                    <MotionNavLink
                      to="/perdidos"
                      className="nav-link custom-nav-link"
                      whileHover={{ scale: 1.05, color: "#1A9EE0" }}
                      transition={{ duration: 0.15 }}
                    >
                      PERDIDOS
                    </MotionNavLink>
                    {/* 
                      <NavLink
                        to="/eventos"
                        className="nav-link custom-nav-link"
                      >
                        EVENTOS
                      </NavLink>
                      */}

                    <MotionNavLink
                      to="/ouropreto"
                      className="nav-link custom-nav-link"
                      whileHover={{ scale: 1.05, color: "#1A9EE0" }}
                      transition={{ duration: 0.15 }}
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      OURO&nbsp;PRETO
                    </MotionNavLink>

                    <MotionNavLink
                      to="/contact"
                      className="nav-link custom-nav-link"
                      whileHover={{ scale: 1.05, color: "#1A9EE0" }}
                      transition={{ duration: 0.15 }}
                    >
                      CONTATO
                    </MotionNavLink>

                    {user ? (
                      <NavDropdown
                        title={
                          <span className="user-dropdown-title">
                            <i className="bi bi-person-circle"></i>
                            <span className="user-name-text">{user.nickname}</span>
                            <i className="bi bi-caret-down-fill" style={{ fontSize: '0.7rem', marginLeft: '4px' }}></i>
                          </span>
                        }
                        id="user-dropdown"
                        align="end"
                        className="custom-user-dropdown"
                      >
                        <NavDropdown.Item
                          as={Link}
                          to="/home"
                          style={{
                            fontWeight: 500,
                            color: "#0d6efd",
                          }}
                        >
                          <i className="bi bi-house-door" style={{ marginRight: "8px" }}></i>
                          Portal
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          onClick={logout}
                          style={{
                            fontWeight: 500,
                            color: "#dc3545",
                          }}
                        >
                          <i className="bi bi-box-arrow-right" style={{ marginRight: "8px" }}></i>
                          Sair
                        </NavDropdown.Item>
                      </NavDropdown>

                    ) : (
                      <Link
                        to="/login"
                        style={navLinkStyle1}
                        className="btn btn-outline-primary btn-lg rounded-pill w-100 login-button"
                      >
                        <i className="bi bi-person"></i> Login
                      </Link>
                    )}
                  </Nav>
                </Navbar.Collapse>
              </Container>
            </Navbar>
          )}
        </div>
      </section>
    </header>
  );
}